import moment from 'moment';
import { browserTime } from 'utils/time';

const isDateTimeValue = (value) => value instanceof Date
  || /^\d{4}-\d{2}-\d{2}[T ]\d{2}:/.test(String(value).trim());

const parseExplicitDate = (value) => {
  if (!value) return null;
  if (isDateTimeValue(value)) {
    const parsedDate = browserTime(value);
    return parsedDate.isValid() ? parsedDate : null;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const startsWithIsoDate = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (startsWithIsoDate) {
    const [, year, month, day] = startsWithIsoDate;
    const parsedDate = moment(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`, 'YYYY-MM-DD', true);
    return parsedDate.isValid() ? parsedDate : null;
  }

  if (!/\b\d{4}\b/.test(raw)) return null;

  const parsedDate = moment(
    raw,
    [
      moment.ISO_8601,
      'M/D/YYYY',
      'MM/DD/YYYY',
      'M-D-YYYY',
      'MM-DD-YYYY',
      'MMM D, YYYY',
      'MMMM D, YYYY',
    ],
    true
  );

  return parsedDate.isValid() ? parsedDate : null;
};

// Date-only drafts retain the legacy UTC day boundaries.
export const previewScheduleInstant = (value, end = false) => {
  const parsed = parseExplicitDate(value);
  if (!parsed) return undefined;
  return isDateTimeValue(value)
    ? parsed.toISOString()
    : `${parsed.format('YYYY-MM-DD')}T${end ? '23:59:59.000' : '00:00:00.000'}Z`;
};
